import { useState as d, useEffect as i } from "react";
const r = { current: null }, c = { current: !1 };
function u() {
  if (c.current = !0, !window.matchMedia) {
    r.current = !1;
    return;
  }
  const e = window.matchMedia("(prefers-reduced-motion)"), t = () => {
    r.current = e.matches;
  };
  e.addEventListener("change", t), t();
}
function a() {
  c.current || u();
  const [e, t] = d(
    r.current ?? !1
  );
  return i(() => {
    if (!window.matchMedia) return;
    const n = window.matchMedia("(prefers-reduced-motion)"), o = () => {
      r.current = n.matches, t(n.matches);
    };
    return n.addEventListener("change", o), () => n.removeEventListener("change", o);
  }, []), e;
}
export {
  a as useReducedMotion
};
//# sourceMappingURL=useReducedMotion.js.map
